import axios from "axios";

console.log("api url" , process.env.REACT_APP_API_URL)
const axiosInstance = axios.create({
  // Point this to your backend API origin.
  // You can override via REACT_APP_API_BASE_URL in .env if needed.
  baseURL:process.env.REACT_APP_API_URL,
  timeout: 10000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor – you can attach headers here if needed
axiosInstance.interceptors.request.use(
  (config) => {
    // If you later store a non-HTTP-only token, attach here.
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor – handle auth errors (no redirect loop)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 401 || status === 403) {
      // Clear any persisted admin info; routing logic will handle redirect.
      if (typeof window !== "undefined") {
        window.localStorage.removeItem("admin");
      }
    }
    return Promise.reject(error);
  },
);

export const pannelInstance = axios.create({
  baseURL: process.env.REACT_APP_PANNEL_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor for adding auth token
pannelInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Or your token storage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
pannelInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 401 || status === 403) {
      // Clear any persisted admin info; routing logic will handle redirect.
      if (typeof window !== "undefined") {
        window.localStorage.removeItem("admin");
      }
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
